import { useSelector } from 'react-redux';
import {
    familyEnableCalendar,
    familyEnableCalendarFree,
    familyEnableCalendarPaid,
    familyFeatureDocuments,
    familyFeatureDocumentsFree,
    familyFeatureDocumentsPaid,
    familyFeaturePreviewFree,
    familyFeaturePreviewPaid,
} from 'reactApp/appHelpers/featuresHelpers/features/familyFunctions';
import { getFamilyAlbumsFeature, getFamilyCalendars, getFamilyFoldersFeature } from 'reactApp/modules/family/family.selectors';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';

export const useFamilyShowFeaturesHook = () => {
    const hasFamilyFoldersFeature = useSelector(getFamilyFoldersFeature);
    const hasFamilyAlbumsFeature = useSelector(getFamilyAlbumsFeature);

    return hasFamilyFoldersFeature && hasFamilyAlbumsFeature;
};

export const useFamilyShowPreviewHook = () => {
    const hasFamilyFoldersFeature = useSelector(getFamilyFoldersFeature);
    const hasFamilyAlbumsFeature = useSelector(getFamilyAlbumsFeature);
    const isPaid = useSelector(UserSelectors.isPaidUser);

    if (hasFamilyFoldersFeature && hasFamilyAlbumsFeature) {
        return false;
    }

    const showToFreeUser = familyFeaturePreviewFree && !isPaid;
    const showToPaidUser = familyFeaturePreviewPaid && isPaid;

    return showToFreeUser || showToPaidUser;
};

export const useShowFamilyDocumentsHook = () => {
    const hasFamilyFoldersFeature = useSelector(getFamilyFoldersFeature);
    const hasFamilyAlbumsFeature = useSelector(getFamilyAlbumsFeature);
    const isPaid = useSelector(UserSelectors.isPaidUser);

    const showToFreeUser = familyFeaturePreviewFree && !isPaid;
    const showToPaidUser = familyFeaturePreviewPaid && isPaid;

    return (
        (showToFreeUser && familyFeatureDocumentsFree) ||
        (showToPaidUser && familyFeatureDocumentsPaid) ||
        (hasFamilyFoldersFeature && hasFamilyAlbumsFeature && familyFeatureDocuments)
    );
};

export const useShowFamilyCalendarHook = () => {
    const hasFamilyFoldersFeature = useSelector(getFamilyFoldersFeature);
    const hasFamilyAlbumsFeature = useSelector(getFamilyAlbumsFeature);
    const isFamilyUser = hasFamilyFoldersFeature && hasFamilyAlbumsFeature;
    const isPaid = useSelector(UserSelectors.isPaidUser);
    const familyCalendars = useSelector(getFamilyCalendars);

    const showToFreeUser = familyEnableCalendarFree && !isPaid;
    const showToPaidUser = familyEnableCalendarPaid && isPaid && !isFamilyUser;

    return showToFreeUser || showToPaidUser || (isFamilyUser && familyEnableCalendar && !!familyCalendars?.[0]);
};
